import { useParams } from "react-router-dom";
import { HomeParams } from "../../app/types";

function useVenueId(): string {
  const { venueId } = useParams<HomeParams>();
  return venueId;
}

export default useVenueId;
